import { NavLink, Link } from "react-router-dom";

const NAV_ITEMS = [
  { to: "/", label: "HOME" },
  { to: "/mission", label: "MISSION" },
  { to: "/newsletter", label: "NEWSLETTER" },
  { to: "/team", label: "TEAM" },
  { to: "/scene", label: "THE VOID", accent: "lime" },
];

function NavItem({ to, label, accent }) {
  const accentClass =
    accent === "lime"
      ? "text-mgfc-lime hover:text-mgfc-lime hover:text-glow-lime"
      : "text-mgfc-fg hover:text-mgfc-cyan hover:text-glow-cyan";
  return (
    <NavLink
      to={to}
      end={to === "/"}
      className={({ isActive }) =>
        [
          "relative px-1 py-2 font-mono text-sm uppercase tracking-[0.25em] transition-colors duration-200",
          accentClass,
          isActive
            ? accent === "lime"
              ? "text-mgfc-lime text-glow-lime"
              : "text-mgfc-cyan text-glow-cyan"
            : "",
        ].join(" ")
      }
    >
      {({ isActive }) => (
        <>
          <span>{label}</span>
          <span
            className={[
              "pointer-events-none absolute left-0 right-0 -bottom-1 h-px transition-opacity duration-200",
              isActive ? "opacity-100" : "opacity-0",
            ].join(" ")}
            style={{
              background:
                accent === "lime"
                  ? "linear-gradient(90deg, transparent, #9FFF00, transparent)"
                  : "linear-gradient(90deg, transparent, #00FFFF, transparent)",
            }}
          />
        </>
      )}
    </NavLink>
  );
}

export default function NavBar() {
  return (
    <header className="sticky top-0 z-40 border-b border-mgfc-border/80 bg-mgfc-bg/70 backdrop-blur-md">
      <div
        className="absolute inset-x-0 top-0 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent, #FF00FF, #00FFFF, transparent)",
        }}
      />
      <nav className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-3 group">
          <img
            src={`${process.env.PUBLIC_URL}/uploads/2018/10/mike-logo-2.png`}
            alt="MGFC"
            className="h-8 w-auto transition-transform duration-200 group-hover:scale-105"
            draggable={false}
          />
          <span className="hidden font-mono text-[10px] uppercase tracking-[0.4em] text-mgfc-fg/50 sm:inline">
            EST. 2018 // FAN-CLUB.OS
          </span>
        </Link>
        <div className="hidden items-center gap-7 md:flex">
          {NAV_ITEMS.map((item) => (
            <NavItem key={item.to} {...item} />
          ))}
        </div>
        <div className="flex items-center gap-3 md:hidden">
          {NAV_ITEMS.slice(0, 4).map((item) => (
            <NavItem key={item.to} {...item} />
          ))}
        </div>
      </nav>
      <div className="md:hidden border-t border-mgfc-border/60">
        <div className="mx-auto max-w-7xl px-4 py-2">
          <NavLink
            to="/scene"
            className={({ isActive }) =>
              [
                "block text-center font-mono text-xs uppercase tracking-[0.3em] py-1",
                isActive ? "text-mgfc-lime text-glow-lime" : "text-mgfc-lime/80 hover:text-mgfc-lime",
              ].join(" ")
            }
          >
            ▸ ENTER THE VOID
          </NavLink>
        </div>
      </div>
    </header>
  );
}
